import { render, staticRenderFns } from "./follow-up-detail.vue?vue&type=template&id=2fb9600c&scoped=true&"
import script from "./follow-up-detail.vue?vue&type=script&lang=js&"
export * from "./follow-up-detail.vue?vue&type=script&lang=js&"
import style0 from "./follow-up-detail.vue?vue&type=style&index=0&id=2fb9600c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9600c",
  null
  
)

export default component.exports